<template>
    <sa-page-layout :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <!-- <graffidi-applicativi-edit-component :idUtente="utente.id" ></graffidi-applicativi-edit-component> -->
            <graffidi-applicativi-edit-component :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></graffidi-applicativi-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GraffidiApplicativiEditComponent from "../components/GraffidiApplicativiEditComponent.vue";
export default {
    components: { SaPageLayout, GraffidiApplicativiEditComponent },
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            linkback: "/graffidiapplicativi",
            jsonData: {},
            showModalLoading: false,
            pathResource: "/digitalsignapplicativi",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
